/* eslint-disable react/no-array-index-key */
import React from 'react';
import styles from './Maintenance.module.scss';
export const Maintenance = ({ heading = 'Sorry for the inconvenience but we’re performing some maintenance at the moment.', message = 'We’ll be back online shortly!', }) => {
    return (<div className={styles.maintenance}>
      <div className={styles.maintenanceHeader}>
        <div className={styles.maintenanceHeaderLogo} role='presentation'>
          <img src='https://www.haven.com/assets/icons/haven_logo_white.svg' alt='Haven'/>
        </div>
      </div>
      <div className={styles.maintenanceContent}>
        {Array.isArray(heading) ? (heading.map((text, key) => <p key={`maintenance-heading-${key}`}>{text}</p>)) : (<p>{heading}</p>)}
        <p>{message}</p>
      </div>
    </div>);
};
